import { render } from "./HomeHeaderBg.vue?vue&type=template&id=522e88a6"
import script from "./HomeHeaderBg.vue?vue&type=script&lang=ts"
export * from "./HomeHeaderBg.vue?vue&type=script&lang=ts"

import "./HomeHeaderBg.vue?vue&type=style&index=0&id=522e88a6&lang=postcss"
script.render = render

export default script